import { useState, Fragment, useEffect, useCallback } from "react";
import { styled } from "@mui/material/styles";
import { grey } from "@mui/material/colors";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Drawer from "@mui/material/Drawer";
import BottomNavigation from "@mui/material/BottomNavigation";
import { useLocation } from "react-router-dom";
import ChairIcon from "@mui/icons-material/Chair";
import BeachAccessIcon from "@mui/icons-material/BeachAccess";
import {
  StyledAppBarDiv,
  StyledBottomNavigationAction,
  StyledLink,
  StyledTab,
  StyledLinkMobile,
  StyledListItem,
  StyledListItemIcon,
  StyledListItemText,
} from "./AppBar.style";
import { Badge } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import AppsIcon from "@mui/icons-material/Apps";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import useAuth from "hooks/use-auth";
import Toast from "helper/toast";
import {
  getStatusRequest,
  getCategorisFromSubMenuForFurnitureRequest,
  getCategorisFromSubMenuForAccessoryRequest,
} from "api/requests";
import useHttp from "hooks/use-http";
import { FaChevronLeft } from "react-icons/fa";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 2, pb: 2 }}>
          <div style={{ overflowY: "auto", height: "65vh" }}>{children}</div>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function AppbarCM() {
  const AuthCTX = useAuth();
  const { request, setLoading } = useHttp();
  const location = useLocation();
  const currentPath = location.pathname.split()[0];

  const [cartCount, setCartCount] = useState(0);
  const [accessorycategoris, setAccessorycategoris] = useState({
    data: [],
    count: 0,
  });
  const [furniturecategoris, setFurniturecategoris] = useState({
    data: [],
    count: 0,
  });

  const [value, setValue] = useState(0);
  const [state, setState] = useState({
    bottom: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const getStatus = useCallback(async () => {
    const res = await request({
      url: getStatusRequest,
    });
    setCartCount(res.cart_contents_count);
  }, [request]);

  const getCategorisForAccessory = useCallback(
    async (search) => {
      const res = await request({
        url: getCategorisFromSubMenuForAccessoryRequest,
      });
      setLoading(false);

      if (res) {
        if (res.count < 1) {
          return setAccessorycategoris({
            count: res.count,
            data: [{ content: " " }],
          });
        }

        let transformedData = res.data.map((items) => ({
          id: items.id,
          title: items.title,
        }));

        setAccessorycategoris({
          data: transformedData,
          count: res.count,
        });
      }
    },
    [request, setLoading]
  );

  const getCategorisForFurniture = useCallback(async () => {
    const res = await request({
      url: getCategorisFromSubMenuForFurnitureRequest,
    });
    setLoading(false);

    if (res) {
      if (res.count < 1) {
        return setFurniturecategoris({
          count: res.count,
          data: [{ content: " " }],
        });
      }

      let transformedData = res.data.map((items) => ({
        id: items.id,
        title: items.title,
      }));

      setFurniturecategoris({
        data: transformedData,
        count: res.count,
      });
    }
  }, [request, setLoading]);

  useEffect(() => {
    if (AuthCTX.isLoggedIn) {
      getStatus();
    }
    getCategorisForAccessory();
    getCategorisForFurniture();
  }, [getCategorisForAccessory, getCategorisForFurniture]);

  const handleLoginCheck = async () => {
    return Toast({
      type: "custom-warn",
      title: "ابتدا باید وارد حساب کاربری خود شوید",
    });
  };

  return (
    <StyledAppBarDiv>
      <Box
        sx={{
          width: "100%",
          position: "fixed",
          bottom: "0px",
          boxShadow: "0px -1px 9px -4px #8080806b",
          zIndex: "1",
          paddingBottom: "5px",
          background: "white",
        }}
      >
        <BottomNavigation
          showLabels
          // value={value}
          // onChange={(event, newValue) => {
          //   setValue(newValue);
          // }}
        >
          {!AuthCTX.isLoggedIn ? (
            <StyledLink to="/login">
              <StyledBottomNavigationAction
                $isActive={"/login" === currentPath}
                label="ورود / ثبت نام"
                icon={<AccountCircleIcon />}
              />
            </StyledLink>
          ) : (
            <StyledLink to="/profile">
              <StyledBottomNavigationAction
                $isActive={"/profile" === currentPath}
                label="حساب کاربری"
                icon={<AccountCircleIcon />}
              />
            </StyledLink>
          )}

          {!AuthCTX.isLoggedIn ? (
            <StyledBottomNavigationAction
              onClick={handleLoginCheck}
              label="سبد خرید"
              icon={<ShoppingCartIcon />}
            />
          ) : (
            <StyledLink to="/shoppingCart">
              {cartCount == 0 ? (
                <StyledBottomNavigationAction
                  $isActive={"/shoppingCart" === currentPath}
                  label="سبد خرید"
                  icon={<ShoppingCartIcon />}
                />
              ) : (
                <StyledBottomNavigationAction
                  $isActive={"/shoppingCart" === currentPath}
                  label="سبد خرید"
                  icon={
                    <Badge
                      color="primary"
                      anchorOrigin={{
                        vertical: "top",
                        horizontal: "left",
                      }}
                      badgeContent={cartCount}
                    >
                      <ShoppingCartIcon />
                    </Badge>
                  }
                />
              )}
            </StyledLink>
          )}
          {["bottom"].map((anchor) => (
            <StyledBottomNavigationAction
              label="دسته بندی ها"
              icon={<AppsIcon />}
              onClick={toggleDrawer(anchor, true)}
              key={anchor}
            />
          ))}
          <StyledLink to="/">
            <StyledBottomNavigationAction
              $isActive={"/" === currentPath}
              label="صفحه اصلی"
              icon={<HomeIcon />}
            />
          </StyledLink>
        </BottomNavigation>
      </Box>

      {["bottom"].map((anchor) => (
        <Fragment key={anchor}>
          {/* <Button onClick={toggleDrawer(anchor, true)}>{anchor}</Button> */}
          <Drawer
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
          >
            <Box sx={{ width: "100%", direction: "ltr !important" }}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="basic tabs example"
                >
                  <StyledTab label="مبلمان" {...a11yProps(0)} />
                  <StyledTab label="اکسسوری" {...a11yProps(1)} />
                </Tabs>
              </Box>
              <TabPanel
                value={value}
                index={0}
                style={{ paddingLeft: "0px", paddingRight: "0px" }}
              >
                <StyledListItem button>
                  <StyledLinkMobile to={"/Furniture"} style={{ width: "100%" }}>
                    <StyledListItemIcon
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                      }}
                    >
                      <FaChevronLeft
                        style={{ marginRight: "6px", color: "#494949" }}
                      />
                    </StyledListItemIcon>
                    <StyledListItemText style={{ color: "#494949" }}>
                      همه محصولات مبلمان
                    </StyledListItemText>
                  </StyledLinkMobile>
                </StyledListItem>
                {furniturecategoris.data.map((category, index) => (
                  <StyledListItem button key={"category" + index}>
                    <StyledLinkMobile
                      to={"/Furniture" + "/" + category.id}
                      style={{ width: "100%" }}
                    >
                      <StyledListItemIcon>
                        <ChairIcon />
                      </StyledListItemIcon>
                      <StyledListItemText>{category.title}</StyledListItemText>
                    </StyledLinkMobile>
                  </StyledListItem>
                ))}
              </TabPanel>
              <TabPanel
                value={value}
                index={1}
                style={{ paddingLeft: "0px", paddingRight: "0px" }}
              >
                <StyledListItem button>
                  <StyledLinkMobile to={"/accessory"} style={{ width: "100%" }}>
                    <StyledListItemIcon
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                      }}
                    >
                      <FaChevronLeft
                        style={{ marginRight: "6px", color: "#494949" }}
                      />
                    </StyledListItemIcon>
                    <StyledListItemText style={{ color: "#494949" }}>
                      همه محصولات اکسسوری
                    </StyledListItemText>
                  </StyledLinkMobile>
                </StyledListItem>
                {accessorycategoris.data.map((category, index) => (
                  <StyledListItem button key={"category" + index}>
                    <StyledLinkMobile
                      to={"/accessory" + "/" + category.id}
                      style={{ width: "100%" }}
                    >
                      <StyledListItemIcon>
                        <BeachAccessIcon />
                      </StyledListItemIcon>
                      <StyledListItemText>{category.title}</StyledListItemText>
                    </StyledLinkMobile>
                  </StyledListItem>
                ))}
              </TabPanel>
            </Box>
          </Drawer>
        </Fragment>
      ))}
    </StyledAppBarDiv>
  );
}

export default AppbarCM;
